import spendingLimitSVG from './payLaterIllustration.svg';
import { RefreshReminder } from './RefreshReminder';
import { useGetBuyerSpendingLimit } from '../../../../api/lending/lapiHooks';
import { formatCurrency } from '../../utils/currency';
import { RefreshExpiredLimits } from '../SpendingLimitCard/components/RefreshExpiredLimits';

function SpendingLimitView({
  setIsSpendingLimitDrawerOpen,
  loadingRefreshSpendingLimit,
  refreshSpendingLimit,
}: {
  setIsSpendingLimitDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  loadingRefreshSpendingLimit: boolean;
  refreshSpendingLimit: () => void;
}) {
  const { spendingLimit } = useGetBuyerSpendingLimit();

  const activeSpendingLimit = spendingLimit?.data?.active_spending_limit;
  const isLimitValid = Boolean(activeSpendingLimit?.is_valid);
  const creditLimit = activeSpendingLimit?.available_amount;

  return (
    <div className="max-w-[720px]">
      <div className="pt-xl">
        <div data-testid="spending-limit-heading">
          {!isLimitValid && (
            <h2 className="m-0 flex items-center gap-s pb-s text-l font-med">
              Click{' '}
              <RefreshExpiredLimits
                className="text-l"
                loading={loadingRefreshSpendingLimit}
                setIsSpendingLimitDrawerOpen={setIsSpendingLimitDrawerOpen}
                refreshSpendingLimit={refreshSpendingLimit}
              />{' '}
              to refresh your spending limit
            </h2>
          )}
          <h2 className="m-0 pb-xl text-l font-med">
            Here's how to use your{' '}
            {isLimitValid && creditLimit !== undefined
              ? formatCurrency(creditLimit)
              : null}{' '}
            spending limit:
          </h2>
        </div>
        <div className="inline-grid grid-cols-[2rem_auto] gap-x-l gap-y-m">
          <div className="mr-s mt-xs inline-flex h-[25px] w-[25px] flex-col items-center justify-center rounded-l border border-success-mid p-2xs font-bold">
            1
          </div>
          <div className="pt-xs">
            Choose to pay with 'Pay Later' from iwocaPay &mdash; with any
            iwocaPay supplier at their checkout or via a link on their invoice
          </div>
          <div className="mr-s mt-xs inline-flex h-[25px] w-[25px] flex-col items-center justify-center rounded-l border border-success-mid p-2xs font-bold">
            2
          </div>
          <div className="pt-xs">
            Sign into your iwocaPay account &mdash; your spending limit will be
            automatically applied
            <img
              src={spendingLimitSVG}
              alt="Pay Later Illustration"
              className="pt-s"
            />
          </div>
          <div className="mr-s mt-xs inline-flex h-[25px] w-[25px] flex-col items-center justify-center rounded-l border border-success-mid p-2xs font-bold">
            3
          </div>
          <div className="pt-xs">
            Finish checking out as normal &mdash; your supplier gets paid
            instantly, you spread the cost over manageable monthly payments
          </div>
        </div>
        <div className="mt-xl">
          <RefreshReminder />
        </div>
      </div>
    </div>
  );
}

export default SpendingLimitView;
